const storeEquipmentService = {
  inactivateSuccess: 'Servicio del equipo desactivado con éxito',
  activateSuccess: 'Servicio del equipo activado con éxito',
  inactivateError: 'Error al desactivar el servicio del equipo',
  activateError: 'Error al activar el servicio del equipo',
}

export default storeEquipmentService;
